// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"16afb1d1","453":"89bcb946"}[chunkId] + ".chunk.js";
};